var CustomFields = require('./gen/custom_fields');

/**
 * This is for compatibility reasons. Please use createEnumOption.
 */
CustomFields.prototype.addEnumOption = CustomFields.prototype.createEnumOption;

/**
 * This is for compatibility reasons. Please use createEnumOption.
 */
CustomFields.prototype.reorderEnumOption =
    CustomFields.prototype.insertEnumOption;

module.exports = CustomFields;



//////////////////
// WEBPACK FOOTER
// ./node_modules/asana/lib/resources/custom_fields.js
// module id = 1441
// module chunks = 0